module.exports = __webpack_public_path__ + "static/img/big-play-button.99c2eb47.svg";